// Константы для Form1

export const getEmptyFormData = () => {
  return {
    // Местоположение
    lat: '',
    lon: '',
    vnum: '',
    // Сведения
    srf: '',
    filial: '',
    lvo: '',
    ulvo: '',
    urc: '',
    kv: '',        // Квартал
    kadnomer: '',  // Кадастровый номер
    // Выдел
    s: '',
    sga: '',
    // Лесопатологический выдел
    lpvid: '',
    slp: '',
    // Информация
    cel: '',
    data: '',      // дата создания карточки
    datar: '',     // дата проведения ВНН
    ekolzona: '',
    kmns: false,
    zonarad: '',
    nmh: '',
    lmh: '',
    itaks1: '',
    // Зависимые данные
    dependentData: {
      organizations: [],
      forestDistricts: [],
      subDistricts: [],
      toponyms: [],
      subjectDataLoadedFor: '',
    }
  };
};

